import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import Common from "us.common";
import { History } from "history";
import { taskManager } from "reducers/TaskManager";

const reducers = {
  ...Common.Reducers,
  taskManager,
};

const rootReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    ...reducers,
  });

export default rootReducer;
